import { Box, Grid, Switch } from '@mui/material'

import { Card } from './styles'

interface SwitchPermanentStorylineProps {
  type: 'fixed' | 'temporary'
}

export const SwitchPermanentStory = ({
  type
}: SwitchPermanentStorylineProps) => {
  return (
    <Grid item xs={12} md={12}>
      <Card variant='outlined'>
        <Switch
          value={type === 'fixed'}
          readOnly
          style={{
            color: '#364AD3'
          }}
        />

        <Box marginLeft={2} fontFamily='Roboto, sans-serif'>
          <b style={{ fontSize: '1rem' }}>Fixar comunicado</b>
          <p style={{ fontSize: '0.875rem', color: '#ADADBD' }}>
            Este ficará visível indefinidamente
          </p>
        </Box>
      </Card>
    </Grid>
  )
}
